import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * 在打开Webview时通过配置基于客户端请求前端页面接口，提前页面接口的请求时间，提高页面渲染速度
 *
 * ## 功能开关
 *
 * 通过Kswitch控制是否开启客户端预请求接口功能
 *
 * [Kswitch地址](https://kswitch.corp.kuaishou.com/#/flag/targeting?project=kwai&environment=production&key=enableWebviewPreload)
 *
 * ## 使用方式
 *
 * 参考[设计文档](https://docs.corp.kuaishou.com/d/home/fcAC1ZBl3UvCgU_iVjU3x-467)
 *
 * ## 数据获取
 *
 * ```javascript
 * import { clientAPIPrefetch } from '@kibt/web-utils/client-api-prefetch'
 *
 * // 接口返回的数据类型
 * type Result = {}
 *
 * clientAPIPrefetch<Result>({
 *      // 与URL中配置相同
 *      path: '/request/xxxx',
 *      // 超时时间 默认30s
 *      timeout: 30000,
 * }).then((data) => {
 *      console.log(data);
 * }).catch(() => {
 *      // 功能不可用，未开启开关 或 未配置预请求接口 或 接口不匹配
 * });
 * ```
 *
 * @packageDocumentation
 */

/* eslint-disable prefer-promise-reject-errors */

/* eslint-disable no-underscore-dangle */
import { parseUrl } from '../url';
/**
 * 获取URL中的预请求参数
 * @returns
 */

var getApiPrefetchPath = function getApiPrefetchPath() {
  var PRELOAD_SIMPLE_API = '__preload_simple_api__';
  var PRELOAD_API = '__preload_api__';
  var query = parseUrl(window.location.href);

  if (query[PRELOAD_SIMPLE_API]) {
    return query[PRELOAD_SIMPLE_API];
  }

  if (query[PRELOAD_API]) {
    try {
      var preloadAPIConf = JSON.parse(query[PRELOAD_API]);
      return preloadAPIConf.path || '';
    } catch (_unused) {
      return '';
    }
  }

  return '';
};
/**
 * 判断客户端是否已发起请求 若客户端发起请求会在UA中注入preload_api/1字段
 *
 * @returns
 */


var isClientRequested = function isClientRequested() {
  var ua = window.navigator.userAgent;
  return /preload_api\/1/.test(ua);
};
/**
 * 对结果进行轮询
 */


var resultPolling = function resultPolling(cb) {
  var timeoutId = null;

  var getResult = function getResult() {
    timeoutId = setTimeout(function () {
      var result = window.preload_api_result;

      if (!result) {
        getResult();
        return;
      }

      clearTimeout(timeoutId);
      cb(result);
    }, 100);
  };

  getResult();

  var pause = function pause() {
    clearTimeout(timeoutId);
  };

  return {
    pause: pause
  };
}; // 该接口数据是否已读取


var isFetched = false;
/**
 * 获取基于客户端请求的接口的返回数据
 *
 * @param config 预请求配置
 * @returns
 * |返回值|说明|
 * |-|-|
 * |-10|预请求接口未配置|
 * |-11|请求路径不匹配|
 * |-12|客户端未发起请求|
 * |-13|数据已销毁|
 * |-999|请求超时|
 */

export var clientAPIPrefetch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
    var prefetchConfig, apiPrefetchPath, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            prefetchConfig = _objectSpread({
              timeout: 30000,
              destroy: true
            }, config);
            apiPrefetchPath = getApiPrefetchPath(); // 未配置预请求接口 或 请求路径与配置的预请求接口不同 或 客户端未发起请求

            if (apiPrefetchPath) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", Promise.reject({
              result: -10,
              message: '预请求接口未配置'
            }));

          case 4:
            if (!(apiPrefetchPath !== prefetchConfig.path)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", Promise.reject({
              result: -11,
              message: '请求路径不匹配'
            }));

          case 6:
            if (isClientRequested()) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", Promise.reject({
              result: -12,
              message: '客户端未请求'
            }));

          case 8:
            if (!(prefetchConfig.destroy && isFetched)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", Promise.reject({
              result: -13,
              message: '数据已销毁'
            }));

          case 10:
            isFetched = true; // 客户端注入数据

            result = window.preload_api_result;

            if (!result) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", result);

          case 14:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var isTimeout = false;
              var isReceiveResult = false;
              var polling;
              var timeoutId;

              var resolveData = function resolveData(data) {
                var _polling, _polling$pause;

                if (isTimeout) {
                  return;
                } // 若已返回数据 则不在处理


                // 若已返回数据 则不在处理
                if (isReceiveResult) {
                  return;
                }

                isReceiveResult = true;
                (_polling = polling) === null || _polling === void 0 ? void 0 : (_polling$pause = _polling.pause) === null || _polling$pause === void 0 ? void 0 : _polling$pause.call(_polling);
                clearTimeout(timeoutId);

                if ((data === null || data === void 0 ? void 0 : data.result) === -999) {
                  reject(data);
                } else {
                  resolve(data);
                }
              }; // 设置超时


              // 设置超时
              timeoutId = setTimeout(function () {
                resolveData({
                  result: -999,
                  message: '请求超时'
                });
                isTimeout = true;
              }, prefetchConfig.timeout);

              if (prefetchConfig.yoda) {
                prefetchConfig.yoda.ready().then(function () {
                  var _prefetchConfig$yoda$;

                  (_prefetchConfig$yoda$ = prefetchConfig.yoda.event) === null || _prefetchConfig$yoda$ === void 0 ? void 0 : _prefetchConfig$yoda$.addEventListener('preload_api_event', function (data) {
                    resolveData(data);
                  }, function (res) {
                    // 监听后再次获取全局属性数据 避免在监听过程中客户端注入数据并触发事件
                    var data = window.preload_api_result;

                    if (data) {
                      resolveData(data);
                    } // Yoda未Ready 使用轮询方式获取


                    // Yoda未Ready 使用轮询方式获取
                    if ((res === null || res === void 0 ? void 0 : res.result) !== 1) {
                      polling = resultPolling(function (data) {
                        resolveData(data);
                      });
                    }
                  });
                });
              } else {
                // 未传Yoda实例 基于定时器轮询获取
                polling = resultPolling(function (data) {
                  resolveData(data);
                });
              }
            }));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function clientAPIPrefetch(_x) {
    return _ref.apply(this, arguments);
  };
}();